import React from 'react';
import { Modal, Divider, Button, Icon } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { isBlockedBySubscriptionLimit } from '../../../../../helpers/subscriptionLimitCheck';

class RegenatePlaybookActivitiesModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            generateDetailsFor: "all",
            errorActivitiesCount: 0,
            allActivitiesCount: 0,
            errors: [],
            errors2: []
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.selectedPracticeLibrary !== this.props.selectedPracticeLibrary ||
            prevProps.selectedPracticeFlowActivity !== this.props.selectedPracticeFlowActivity || prevProps.generateDetailsOpen !== this.props.generateDetailsOpen) {
            this.calculateErrorActivitiesCount();
        }
        if(prevProps.generateDetailsOpen !== this.props.generateDetailsOpen){
            this.checkContent();
        }
    }

    calculateErrorActivitiesCount = () => {
        const { selectedPracticeLibrary, selectedPracticeFlowActivity, reference } = this.props;
        let errorActivitiesCount = 0;
        let allActivitiesCount = 0;

        if (selectedPracticeLibrary && selectedPracticeLibrary.activities) {
            for (let phase of selectedPracticeLibrary.activities) {
                for (let stage of phase.activities) {
                    if (reference === "stage" && selectedPracticeFlowActivity._id !== stage._id) {
                        continue;
                    }
                    for (let activity of stage.activities) {
                        if (activity.aiGenStatus === -1) {
                            errorActivitiesCount++;
                        }
                        allActivitiesCount++;
                    }
                }
            }
        }

        this.setState({ errorActivitiesCount,allActivitiesCount });
    }
    disableErrorRadio = () => {
        return this.state.errorActivitiesCount === 0;
    }
    handleClose = async (e) => {
        this.setState({
            generateDetailsFor:"all"
        })
        this.props.generateDetails(false);
    }

    handleCancle = (e) => {
        this.handleClose();
    }

    handleSubmit = async (e) => {
        this.handleClose();
        const { accountSubscriptionDetail } = this.props
        let defaults = accountSubscriptionDetail.consumptionDefaults || {};
        let requiredCredits = defaults.linksGenerated * 7;
        if (this.state.generateDetailsFor === "error") {
            requiredCredits = defaults.linksGenerated * 7 * this.state.errorActivitiesCount;
        } else {
            requiredCredits = defaults.linksGenerated * 7 * this.state.allActivitiesCount;
        }
        if (isBlockedBySubscriptionLimit({
            accountSubscriptionDetail,
            selectedAccount: this.props.selectedAccount,
            user: this.props.user,
            requiredCredits,
            entity: "Actvities",
            entityType: "Link Generation for Activities",
        })) {
            // blocked, modal shown by helper
        } else {
            try {
                if (this.state.generateDetailsFor !== "error") {
                    if(this.props.reference === "stage"){
                        let payload = {
                            stageIds : [this.props.selectedPracticeFlowActivity._id]
                        }
                        await dispatch.lifeCycle.allActivitiesWebSearch(payload);
                    } else {
                        await dispatch.lifeCycle.allActivitiesWebSearch();
                    }
                } else {
                    if(this.props.reference === "stage"){
                        let payload = {
                            stageIds : [this.props.selectedPracticeFlowActivity._id],
                            type: "error"
                        }
                        await dispatch.lifeCycle.allActivitiesWebSearch(payload);
                    } else {
                        await dispatch.lifeCycle.allActivitiesWebSearch({ type: "error" });
                    }
                }
            } catch (error) {
                console.error('Error generating details:', error);
            }
        }
    }

    checkContent = () => {
        let errors = []
        let errors2 = []
        const checkErrors = (phase) => {
            if (phase.activities) {
                if (phase.activities.length === 0) {
                    errors.push(`Activity ${phase.name} should contain at least one leaf Activity`);
                    errors2.push({
                        type: "sequence",
                        phase: phase.name,
                        description: "To generate details, please include at least one leaf Activity."
                    });
                }

                for (const stage of phase.activities) {
                    if (stage.activities) {
                        if (stage.isParentNode && stage.activities.length === 0 && !stage.integration) {
                            errors.push(`Activity ${phase.name} > ${stage.name} should contain at least one leaf Activity`);
                            errors2.push({
                                type: "sequence",
                                phase: phase.name,
                                stage: stage.name,
                                description: "To generate details, please include at least one leaf Activity."
                            });
                        }
                    }
                    else {
                        errors.push(`Activity ${phase.name} > ${stage.name} should contain at least one leaf Activity`);
                        errors2.push({
                            type: "sequence",
                            phase: phase.name,
                            stage: stage.name,
                            description: "To generate details, please include at least one leaf Activity."
                        });
                    }

                }
            }
            else {
                errors.push(`Activity ${phase.name} should contain at least one leaf Activity`);
                errors2.push({
                    type: "sequence",
                    phase: phase.name,
                    description: "To generate details, please include at least one leaf Activity."
                });
            }
        }
        if (this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.activities) {
            for (const phase of this.props.selectedPracticeLibrary.activities) {
                if(this.props.reference == "stage" && this.props.selectedPracticeFlowActivity && this.props.selectedPracticeFlowActivity._id){
                    if(this.props.selectedPracticeFlowActivity.parentActivity && this.props.selectedPracticeFlowActivity.parentActivity._id && (phase._id).toString() === (this.props.selectedPracticeFlowActivity.parentActivity._id).toString()){
                        checkErrors(phase);
                    }
                } else {
                    checkErrors(phase);
                }
            }
        }
        this.setState({ errors: errors, errors2: errors2 });
    }
    render() {
        const { selectedPracticeLibrary, selectedPracticeFlowActivity } = this.props

        let confirm = <React.Fragment>
            <p>Do you want to Generate Details for activities in <b>"{this.props.reference === "stage" ? selectedPracticeFlowActivity.name :selectedPracticeLibrary.name}"</b>? </p>
            <p>This action will also delete and then generate new attachment links and metadata of the activities in <b>"{this.props.reference === "stage" ? selectedPracticeFlowActivity.name :selectedPracticeLibrary.name}"</b>.</p>
            <p>Do you want to duplicate your Playbook first and then come back to proceed?</p>
            <p style={{color:"#FF8F00"}}>This action is not reversible</p>
            <Form.Field >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{marginRight:'5px'}}>
                    <Form.Radio
                        name='generate'
                        label='Generate All Activities'
                        value={"all"}
                        checked={this.state.generateDetailsFor === "all"}
                        onChange={(e)=>{this.setState({ generateDetailsFor: "all" })}}
                    /></div>
                    <div style={{fontSize:'10px',fontWeight:'700',color:'#0009', marginleft: '10px',marginBottom:"8px", backgroundColor:"#e8e8e8", padding:"3px 5px", borderRadius:"4px"}}>{this.state.allActivitiesCount}</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{marginRight:'5px'}}>
                    <Form.Radio
                        name='generate'
                        label='Generate only error activities'
                        value={"error"}
                        disabled={this.disableErrorRadio()}
                        checked={this.state.generateDetailsFor === "error"}
                        onChange={(e) => { this.setState({ generateDetailsFor: "error" }) }}
                    /></div>
                    <div style={{fontSize:'10px',fontWeight:'700',color:'#0009', marginleft: '10px',marginBottom:"8px", backgroundColor:"#e8e8e8", padding:"3px 5px", borderRadius:"4px"}}>{this.state.errorActivitiesCount}</div>
                </div>
            </Form.Field>
            <div>
                {this.state.errors2.map((error, i) => {
                    return (
                        <div key={i} style={{marginTop:"20px"}} className="error_body">
                            <div className="error_desc">
                                <strong>{error.phase} {error.stage ? <Icon name="angle right" /> : ""}{error.stage ? error.stage : ""} {error.activity ? <Icon name="angle right" /> : ""} {error.activity ? error.activity : ""} </strong> <br />
                                <span style={{color: "#FF9138"}}>{error.description}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </React.Fragment >

        return (
            <Modal
                animated
                open={this.props.generateDetailsOpen}
                onClose={this.handleClose}
                size='small'
                className="basicModal"
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
            >
                <Modal.Header>
                    Generate Activity Details
                </Modal.Header>
                <Divider style={{ margin: "10px 0 0px" }} />
                <Modal.Content scrolling>
                    <Form noValidate
                        id='copyPlay'
                        onValidSubmit={(data) => this.handleSubmit(data)}
                        className="formcyForm"
                    >
                        {confirm} <br />
                    </Form>
                </Modal.Content>

                <Modal.Actions className="actionInFormcy">
                    <Button
                        className="button-submit float-right"
                        id='copyPlaybook'
                        onClick={this.handleSubmit}
                    > Generate Details </Button>
                    <Button
                        id='copyCancel'
                        className="button-cancel"
                        onClick={this.handleClose}
                    > Cancel </Button>
                </Modal.Actions>
            </Modal>
        )
    }
}

export default RegenatePlaybookActivitiesModal;